<div class="cp-serial-check">
  <div class="cp-title">
    {{ 'serial_check_title' | translate }}
  </div>
  <div class="cp-subtitle">
    {{ 'serial_check_subtitle' | translate }}
  </div>

  <form [formGroup]="form">
    <div class="cp-field">
      <div class="cp-control">
        <input class="cp-input" type="text" formControlName="serial" placeholder="{{ 'serial' | translate }}">
      </div>
    </div>

    <button class="coupon-button" (click)="search()">
      {{ 'search' | translate | uppercase }}
    </button>
  </form>

  @if (notFound()) {
  <div class="cp-title cp-not-found">
    {{ 'serial_not_registered' | translate }}
  </div>
  }

  @if (registeredSerial()) {
  <div class="cp-table">
    <div class="cp-trainer-img">
      <img [src]="getTrainerImageURL(registeredSerial()?.trainerCode ?? 0)">
    </div>

    <div class="cp-table-data">
      <div class="cp-trainer-name">
        {{ registeredSerial()?.trainerName }}
      </div>
      @if (registeredSerial()?.purchaseDate) {
      <div class="cp-trainer-data">
        {{ 'purchased_on' | translate }} {{ purchaseDate() | dateFormatted }}
      </div>
      }
      @if (registeredSerial()?.warrantyAcceptDate) {
      <div class="cp-trainer-data">
        <strong>{{ 'extended_support' | translate }}</strong> -
        @if (expired()) {
          {{ 'expired_on' | translate }}
        }
        @else {
          {{ 'expires_on' | translate }}
        }
        {{ termDate() | dateFormatted }}
      </div>
      }
      @else {
      <div class="cp-trainer-data">
        <strong>{{ 'standard_support' | translate }}</strong>
      </div>
      }
    </div>
  </div>
  }
</div>
